module.exports = __webpack_public_path__ + "img/goto_music.03920f3b.jpg";